import { useContext } from 'react';

import styles from '../../article.module.css';

import { ArticleContext } from '../../Article.context';
import { VirtualCaption } from './Caption';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

export const VirtualMap = (props: MapProps) => {
	const {
		id = '',
		latitude,
		longitude,
		zoom = 5,
		caption = '',
		captionEnabled = false,
		bleed,
		fullWidth,
	} = props;
	const className = [styles['map'], 'media'];
	if (bleed && !fullWidth) {
		className.push('bleed');
	}
	return (
		<figure id={id} className={className.join(' ')}>
			<MapContainer
				center={[latitude, longitude]}
				zoom={zoom}
				scrollWheelZoom={false}
			>
				<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
				<Marker position={[latitude, longitude]} />
			</MapContainer>
			{captionEnabled && caption ? (
				<VirtualCaption content={caption} />
			) : null}
		</figure>
	);
};

interface MapProps {
	id: string;
	bleed: boolean;
	latitude: number;
	longitude: number;
	fullWidth?: boolean;
	zoom: number;
	marker: boolean;
	caption: string;
	captionEnabled: boolean;
}
